import { makeStyles, tokens, shorthands } from '@fluentui/react-components';
import { fontScale } from '@/theme';

export const useCancelBookingDialogStyles = makeStyles({
  surface: {
    maxWidth: '480px',
    width: '90vw',
    '& button': {
      whiteSpace: 'nowrap',
    },
  },
  bodyText: {
    fontSize: fontScale.body,
    lineHeight: tokens.lineHeightBase300,
    color: tokens.colorNeutralForeground1,
    margin: '0',
  },
  confirmQuestion: {
    fontSize: fontScale.body,
    lineHeight: tokens.lineHeightBase300,
    color: tokens.colorNeutralForeground1,
    fontWeight: tokens.fontWeightSemibold,
    margin: '0',
    marginTop: tokens.spacingVerticalM,
  },
  reasonSection: {
    marginTop: tokens.spacingVerticalM,
  },
  label: {
    display: 'block',
    marginBottom: tokens.spacingVerticalXS,
  },
  required: {
    color: tokens.colorPaletteRedForeground1,
  },
  textarea: {
    width: '100%',
    minHeight: '80px',
  },
  charCount: {
    display: 'block',
    textAlign: 'right',
    fontSize: fontScale.caption,
    color: tokens.colorNeutralForeground3,
    ...shorthands.margin(tokens.spacingVerticalXXS, '0', '0', '0'),
  },
  errorText: {
    color: tokens.colorPaletteRedForeground1,
    fontSize: fontScale.caption,
    ...shorthands.margin(tokens.spacingVerticalXS, '0', '0', '0'),
  },
});
